export default "__VITE_ASSET__c95bc499__"